module.exports = __webpack_public_path__ + "img/CMHK_03_zhCn.7df1ea64.png";